module.exports = __webpack_public_path__ + "static/media/ice2.eab66aca.png";